import React, { useEffect, useState, useRef } from 'react';
import { mfaOtpStyles } from '../../mobilecomponents/my-login/mfaOtpStyles';
import {
    TextField,
    Grid,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    useTheme,
} from '@material-ui/core';

import { Typography } from '@material-ui/core';
import { Box } from '@material-ui/core';
import phoneIcon from '../../mobilecomponents/images/phone_icon.svg';
import { usePhoneNumber } from '../../sharedcomponents/css/usePhoneNumber';
// import SuccessPopup from './SuccessPopup';
import EirButton from '../../theme/EirButton';
import AlertOfForgotPassword from '../../mobilecomponents/my-login/AlertOfForgotPassword';
import { useWindowDimension } from '../../hooks/windowDimensions';
import ENDPOINTS from '../../components/graphql/GraphQLConstants';
import { useApolloClient } from '@apollo/client';
import MyEirRegisterHeader from './reusable/MyEirRegisterHeader';
import MyEirRegisterFooter from './reusable/MyEirRegisterFooter';
import { sendMfaOtp } from '../../mobilecomponents/my-login/loginOperation.api';
import RegistrationSupportError from './RegistrationSupportError';
import ReCAPTCHA from 'react-google-recaptcha';
import END_POINT from '../../components/graphql/GraphQLConstants';

const RegisterContactNumScreen = props => {
    const graphql = useApolloClient();
    const theme = useTheme();
    const [code, setCode] = useState('');
    const mobileServices = props.serviceNumbers;
    const [showCaptcha, setShowCaptcha] = useState(true);
    const [captchaValue, setCaptchaValue] = useState(null);
    const [isRecaptchaNull, setIsRecaptchaNull] = useState(true);
    const [captchaFailed, setCaptchaFailed] = useState('');
    const recaptchaRef = useRef(null);
  
    const [singleServices, setSingleServices] = useState(false);
    const [openList, setOpenList] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [width, height] = useWindowDimension();
    const classes = usePhoneNumber();
    const [activeCode, setActiveCode] = useState(false);
    const [enableSubmit, setEnableSubmit] = useState(false);
    const useStyle = mfaOtpStyles({ activeCode });
    const [invalidPhone, setInvalidPhone] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showLabelPhone, setShowLabelPhone] = useState(false);
    const [areaCodeOption, setAreaCodeOption] = useState([]);

    const [phoneNum, setPhoneNum] = React.useState({
        value: null,
        displayNumber: '',
        pattern: /^[0-9]*$/,
        error: { value: false, message: 'Please enter a valid number' },
    });
    const toggle3 = () => {
        setShowError(!showError);
    };

    const handleContactNumber = async value => {
        if (singleServices) {
            sessionStorage.setItem('reg_phone_number', mobileServices?.[0]?.number);
            props.setSelectedContact(mobileServices?.[0]?.number);
        }
        try {
            const res = await graphql.mutate({
                mutation: END_POINT.NUMBER_VALIDATION,
                variables: {
                    registerWith: 'NUMBER' || 'EMAIL',
                    registerValue: sessionStorage.getItem('reg_phone_number'),
                    recaptcha: value, // NEED TO SEND PROPER RECAPTCHA HERE
                },
            });

            if (
                res.data.validateUser.statusCode == 201 ||
                res.data.validateUser.statusCode == 202
            ) {
                sessionStorage.setItem('reg_uuid', res.data.validateUser.otpUuid);
                setShowCaptcha(false);
                props.handleNext(2);
            }
            if (res.data.validateUser.statusCode == 203) {
            }
        } catch (e) {
            console.log('error in contact num step', e);
        }
    };
    const handleOnChange = async value => {
        try {
            if (!value) {
                setCaptchaValue(null);
                setIsRecaptchaNull(true);
                return;
            }
           
            else {
                setCaptchaValue(value);
                setIsRecaptchaNull(false);
                setCaptchaFailed('');

                // await handleContactNumber(value);
            }
        } catch (err) {
            console.error(err.message);
            setCaptchaFailed('Captcha is not valid');
        }
    };
    const handleBackButton = () => {
        props.handleBackButton(3);
    };

    useEffect(() => {
        setSingleServices(mobileServices.length === 1);
        setIsMobile(mobileServices.length > 0);
    }, [mobileServices]);

    return (
        <>
            <div className={useStyle.otpContainer}>
                <div className={useStyle.otpcardContainerMFA}>
                    <MyEirRegisterHeader
                        headerText='Secure your account'
                        handleBackButton={handleBackButton}
                    />

                    {/* body part */}
                    <div className={`${useStyle.bodyMFA} verification-body`}>
                        <Grid container>
                            <Grid item xs={12}>
                                <div
                                    className={useStyle.text}
                                    style={
                                        width < 600
                                            ? {
                                                  minHeight: '46px',
                                                  marginTop: '6px',
                                                  marginBottom: '24px',
                                              }
                                            : {}
                                    }
                                >
                                    {singleServices && (
                                        <Typography className={useStyle.contactText}>
                                            Important. Please confirm the mobile number you would
                                            like us to send your verification codes to.
                                        </Typography>
                                    ) }

                                    <>
                                        {singleServices && (
                                            <Box
                                                className={useStyle.contact}
                                                style={{ display: 'flex' }}
                                            >
                                                <Box
                                                    component='img'
                                                    src={phoneIcon}
                                                    alt=''
                                                    className={useStyle.phoneIcon}
                                                />
                                                <Typography className={useStyle.contactNum}>
                                                    {/* 085 123 4567 */}
                                                    {mobileServices?.[0]?.number}
                                                </Typography>
                                            </Box>
                                        ) }
                                    </>

                                    <div
                                        className={useStyle.notice}
                                        style={
                                            phoneNum.error.value && width < 600
                                                ? { marginTop: '35px' }
                                                : {}
                                        }
                                    >
                                        <AlertOfForgotPassword email='' flag='mfa' />
                                    </div>
                                </div>
                                {/* recaptcha */}
                                <Grid container>
                                    <Grid item xs={12}>
                                        {showCaptcha && (
                                            <Grid
                                                container
                                                sm={12}
                                                xs={12}
                                                md={12}
                                                className={useStyle.gridRecaptcha}
                                            >
                                                <div className={useStyle.reCaptcha}>
                                                    <ReCAPTCHA
                                                        ref={recaptchaRef}
                                                        className={useStyle.reCaptchaRobot}
                                                        sitekey='6LfZsRYTAAAAAJMBqawqK3sy7NmHDC8M9rKdkX36'
                                                        render='explicit'
                                                        onChange={handleOnChange}
                                                    />
                                                </div>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    className={useStyle.errormessage}
                                                >
                                                    {isRecaptchaNull ? (
                                                        <div className='invalid-messages'>
                                                            {captchaFailed}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>

                    <div className={useStyle.footer}>
                        {!isLoading ? (
                            <MyEirRegisterFooter
                                ariaLabel1='Continue to next step'
                                button1Text='Confirm & continue'
                                handleButton1Click={() => handleContactNumber(captchaValue)}
                                button1Enabled={
                                    singleServices && !isRecaptchaNull
                                        ? true
                                        : !invalidPhone && enableSubmit && !isRecaptchaNull
                                        ? enableSubmit
                                        : false
                                }
                            />
                        ) : (
                            <EirButton
                                variants='primaryButtonMedium'
                                style={{ padding: '0.5rem 2.5rem' }}
                                // className={classes.paymentContent}
                            >
                                <CircularProgress
                                    disableShrink
                                    style={{
                                        color: 'white',
                                        width: '17px',
                                        height: '17px',
                                        marginRight: '5px',
                                    }}
                                />
                                Continuing...
                            </EirButton>
                        )}
                    </div>
                    {showError ? (
                        <RegistrationSupportError
                            open={showError}
                            setOpen={setShowError}
                            subtext={' '}
                            buttonText={'Close'}
                            footerText={''}
                            headText="Sorry, we can't find a valid contact number."
                            newsContentText="We can't seem to find a valid contact number for your account on our system.
                                                         "
                        />
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </>
    );
};

export default RegisterContactNumScreen;
